module.exports = __webpack_public_path__ + "img/trade.51982178.png";